import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchPermanentJobsList } from '../../../../../services/pp';

export const useUserPermanentJobList = (userId) => {
  const [filters, setFilters] = useState({
    page: 1,
    limit: 15,
    recruiter: '',
    professionType: '',
    status: '',
    searchText: '',
  });

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['fetchUserPermanentJobList', filters, userId],
    queryFn: () => fetchPermanentJobsList(filters, userId),
    retry: false,
    enabled: !!userId,
  });

  const handleFilterChanged = useCallback(
    (type, value) => {
      setFilters((prev) => ({ ...prev, [type]: value, page: 1 }));
    },
    [setFilters],
  );

  const handlePageChanged = useCallback(
    (page) => {
      setFilters((prev) => ({ ...prev, page }));
    },
    [setFilters],
  );

  return {
    data: response?.data || [],
    filters,
    isLoading,
    total: response?.metadata?.pagination?.total || 0,
    totalPages: Math.ceil((response?.metadata?.pagination?.total || 0) / filters.limit) || 1,
    isError,
    error,
    handleFilterChanged,
    handlePageChanged,
  };
};
